import React, { Component } from 'react';
import classnames from 'classnames';
import { string, arrayOf, object, func } from 'prop-types';

import Article from './Article/Article';
import ActionIcon from 'elements/ActionIcons/ActionIcon';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './NewsBanner.css';

class NewsBanner extends Component {
  static propTypes = {
    label: string,
    pageLink: string,
    pageCallback: func,
    news: arrayOf(object).isRequired,
    className: string
  }

  static defaultProps = {
    label: 'Latest News',
    pageLink: 'View All'
  }

  renderNews = () => {
    const { news } = this.props;

    return news.map((article, i) => <Article key={`new-${i}`} {...article} />);
  }

  render () {
    const { className, label, pageLink, pageCallback } = this.props;

    return (
      <section className={classnames(styles.news, className)}>
        <div className={styles.head}>
          <p className={styles.labelTitle}>{label}</p>
          <LinkFreeStanding
            className={styles.pageLink}
            icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
            onClick={pageCallback}
            withBouncing
            size="m"
          >
            {pageLink}
          </LinkFreeStanding>
          <ActionIcon
            icon="link-arrow-right"
            type="30"
            customClasses={styles.pageIcon}
            onClick={pageCallback}
          />
        </div>
        <ul className={styles.container}>
          {this.renderNews()}
        </ul>
      </section>
    );
  }
}

export default NewsBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/NewsBanner/NewsBanner.js